import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type CreateConstructionInput, createConstruction } from "@/adapters/api";
import { type Obra, toObra } from "@/features/stages/obra.ts";
import { useActiveContext } from "@/store/use-active-context.ts";

export function useCreateObra() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: (input: Omit<CreateConstructionInput, "worksiteId">) => {
			if (!activeCanteiroId) {
				throw new Error("Selecione um canteiro antes de criar uma obra.");
			}
			return createConstruction({ ...input, worksiteId: activeCanteiroId });
		},
		onSuccess: (created) => {
			const obra = toObra(created);
			queryClient.setQueryData<Obra[]>(["obras"], (old) =>
				old ? [...old, obra] : [obra],
			);
			queryClient.invalidateQueries({ queryKey: ["obras"] });
		},
	});
}
